import { Link } from "react-router-dom";

/**
 * Compact hero used by every inner public page: breadcrumb, one H1 and an optional subtitle.
 * crumbs: [{ label, to? }] after "Home"; the last crumb is the current page.
 */
const PageHero = ({ title, subtitle, crumbs = [], children }) => (
  <header className="lp-pagehero">
    <div className="container">
      <nav aria-label="Breadcrumb">
        <ol className="lp-crumbs">
          <li><Link to="/">Home</Link></li>
          {crumbs.map((crumb, i) => (
            <li key={crumb.label}>
              {crumb.to && i < crumbs.length - 1 ? (
                <Link to={crumb.to}>{crumb.label}</Link>
              ) : (
                <span aria-current={i === crumbs.length - 1 ? "page" : undefined}>{crumb.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
      <h1 className="lp-pagehero__title">{title}</h1>
      {subtitle && <p className="lp-pagehero__sub">{subtitle}</p>}
      {children}
    </div>
  </header>
);

export default PageHero;
